angular.module('eatself')
.directive('imageScale', function($compile, ShopService, $timeout) {
	return {
		scope: false,
		link: function($scope, $element, $attrs) {
			let imageScale = $attrs.imageScale;
			if (imageScale == "") {
				imageScale = ShopService.shop.info.display.stretchProductImage;
			} else {
				imageScale = !!+imageScale;
			}
			$element.css('transition','none');
			$element.one('error',(ev)=>{
				imageScale = false;
				$element.css('transform','');
			});
			scale_image();
			$(window).resize(() => scale_image());
			$(window).load(() => scale_image());
			function scale_image() {
				$timeout(() => {
					if (imageScale) {
						let parent = $element.parents($attrs.imageScaleParent);
						var widthProdImg = $element.width();
						var widthProdBlock = parent.width();
						var coefWidth = widthProdBlock / widthProdImg;

						var heightProdImg = $element.height();
						var heightProdBlock = parent.height();
						var coefheight = heightProdBlock / heightProdImg;

						if (widthProdImg < widthProdBlock) {
							$element.css({transform: 'scale(' + coefWidth + ')'});
						};

						if (heightProdImg < heightProdBlock) {
							$element.css({transform: 'scale(' + coefheight + ')'});
						};
					}
				})
			}
		}
	};
})
